module.exports = __webpack_public_path__ + "static/media/video-placeholder.62631a89.svg";